class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    
    // Initialize current variant data
    this.updateOptions();
    this.updateMasterId();
    
    this.setupQuantityListener();
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGridySlider = document.getElementById(`slider-${this.dataset.section}`);
    const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${this.dataset.section}`);
    
    if (mediaGridySlider) {
      mediaGridySlider.scrollToSlideByID(
        `item-${this.currentVariant.featured_media.id}`
      );
    }
    
    if (thumbnailsGridySlider) {
      thumbnailsGridySlider.scrollToSlideByID(`thumbnail-item-${this.currentVariant.featured_media.id}`)
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector('[data-product-inventory]');

    if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

    this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
    this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management) {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add('hide');
      return;
    }

    this.productInventoryNode.classList.remove('inventory-status--in-stock', 'inventory-status--low', 'inventory-status--sold-out', 'inventory-status--sold-out-continue-selling');

    if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold) && parseInt(quantity) > 0) {
      this.productInventoryNode.classList.add('inventory-status--low');
      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) > parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.add('inventory-status--in-stock');
      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) < 1) {
      this.productInventoryNode.classList.add('inventory-status--sold-out-continue-selling');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock_continue_selling;
    } else {
      this.productInventoryNode.classList.add('inventory-status--sold-out');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
    }

    this.productInventoryNode.classList.remove('hide');
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date ?
      window.variantStrings.inventory.waiting_for_stock : 
      window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const destinationBuyBarInfo = document.getElementById(
          `buy-bar-info-${this.dataset.section}`
        );
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const buyBarInfoSource = html.getElementById(`buy-bar-info-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationBuyBarInfo) destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.unavailable);
        
        // Update quantity-based price after the server response has updated the DOM
        this.updateQuantityBasedPrice();
        // Update the live cart price rendered inside the sticky buy bar CTA.
        this.updateBuyBarButtonPrice();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const multiplyButtons = productForm.querySelectorAll('.btn--add-multiplier');
    const quantityInputs = productForm.querySelectorAll('quantity-input');
    const quantityLabels = productForm.querySelectorAll('.form__label[for*="Quantity"]');
    if (!addButton) return;

    if (disable) {
      if (modifyClass) {
        addButton.setAttribute('disabled', 'disabled');
      }
      if (text) addButtonText.textContent = text;
      if (modifyClass) {
        addButton.classList.remove('btn--primary');
        addButton.classList.add('btn--secondary');
      }
      // Hide quantity selectors when unavailable (only when we are applying full UI changes)
      if (modifyClass) {
        if (quantityInputs) {
          quantityInputs.forEach(input => {
            input.style.display = 'none';
          });
        }
        if (quantityLabels) {
          quantityLabels.forEach(label => {
            label.style.display = 'none';
          });
        }
      }
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.disabled = true;
          if (modifyClass) {
            button.classList.remove('btn--primary');
            button.classList.add('btn--secondary');
          }
        });
      }
    } else {
      if (modifyClass) {
        addButton.removeAttribute('disabled');
      }
      if (this.dataset.isPreorder == 'true') {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (modifyClass) {
        // Always use the primary (filled) style when the variant is available,
        // regardless of whether dynamic checkout buttons are present.
        addButton.classList.remove('btn--secondary');
        addButton.classList.add('btn--primary');
      }
      // Show quantity selectors when available (only when we are applying full UI changes)
      if (modifyClass) {
        if (quantityInputs) {
          quantityInputs.forEach(input => {
            input.style.display = '';
          });
        }
        if (quantityLabels) {
          quantityLabels.forEach(label => {
            label.style.display = '';
          });
        }
      }
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.removeAttribute('disabled');
          if (modifyClass) {
            // Always use the primary (filled) style when available.
            button.classList.remove('btn--secondary');
            button.classList.add('btn--primary');
          }
        });
      }
    }

    const productForm_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    if (productForm_BuyBar) {
      const addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
      // The buy bar CTA has a structured inner: label + separator + price.
      // We only rewrite the label text; separator + price are toggled via the
      // `hidden` attribute so they disappear when the variant is unavailable.
      const addButtonLabel_BuyBar = productForm_BuyBar.querySelector(
        '[name="add"] .product-form__submit-label'
      ) || productForm_BuyBar.querySelector('[name="add"] > span');
      const addButtonSeparator_BuyBar = productForm_BuyBar.querySelector(
        '[name="add"] .product-form__submit-separator'
      );
      const addButtonPrice_BuyBar = productForm_BuyBar.querySelector(
        '[name="add"] .product-form__submit-price'
      );

      if (disable) {
        addButton_BuyBar.setAttribute("disabled", "disabled");
        if (text && addButtonLabel_BuyBar) addButtonLabel_BuyBar.textContent = text;
        if (addButtonSeparator_BuyBar) addButtonSeparator_BuyBar.hidden = true;
        if (addButtonPrice_BuyBar) addButtonPrice_BuyBar.hidden = true;
        if (modifyClass) {
          addButton_BuyBar.classList.remove('btn--primary');
          addButton_BuyBar.classList.add('btn--secondary');
        }
      } else {
        addButton_BuyBar.removeAttribute("disabled");
        if (addButtonLabel_BuyBar) {
          if (this.dataset.isPreorder == "true") {
            addButtonLabel_BuyBar.textContent = window.variantStrings.preOrder;
          } else {
            addButtonLabel_BuyBar.textContent = window.variantStrings.addToCart;
          }
        }
        if (addButtonSeparator_BuyBar) addButtonSeparator_BuyBar.hidden = false;
        if (addButtonPrice_BuyBar) addButtonPrice_BuyBar.hidden = false;
        if (modifyClass) {
          // Buy bar never renders dynamic checkout buttons, so always use the
          // primary (filled) style when the variant is available.
          addButton_BuyBar.classList.remove('btn--secondary');
          addButton_BuyBar.classList.add('btn--primary');
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');

    const button_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    if (!button_BuyBar) return;
    const addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
    const addButtonLabel_BuyBar = button_BuyBar.querySelector(
      '[name="add"] .product-form__submit-label'
    ) || button_BuyBar.querySelector('[name="add"] > span');
    const addButtonSeparator_BuyBar = button_BuyBar.querySelector(
      '[name="add"] .product-form__submit-separator'
    );
    const addButtonPrice_BuyBar = button_BuyBar.querySelector(
      '[name="add"] .product-form__submit-price'
    );
    if (!addButton_BuyBar) return;
    if (addButtonLabel_BuyBar) addButtonLabel_BuyBar.textContent = window.variantStrings.unavailable;
    if (addButtonSeparator_BuyBar) addButtonSeparator_BuyBar.hidden = true;
    if (addButtonPrice_BuyBar) addButtonPrice_BuyBar.hidden = true;
  }

  updateBuyBarButtonPrice() {
    // Renders the actual price the customer is adding to cart (variant.price * qty)
    // inside the sticky buy bar CTA. The buy bar's info area keeps the product
    // default price (e.g. "from XX,XX €") and is intentionally not updated here.
    const priceNode = document.querySelector(
      `#product-form-${this.dataset.section}-product-buy-bar [data-buy-bar-price]`
    );
    if (!priceNode || !this.currentVariant) return;

    const quantityInput = document.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? (parseInt(quantityInput.value) || 1) : 1;
    const totalPrice = this.currentVariant.price * quantity;
    priceNode.textContent = this.formatPrice(totalPrice);
  }

  updateQuantityBasedPrice() {
    const quantityInput = document.querySelector('input[name="quantity"]');
    const priceElement = document.getElementById(`price-${this.dataset.section}`);
    
    if (!quantityInput || !priceElement || !this.currentVariant) return;
    
    const quantity = parseInt(quantityInput.value) || 1;
    const unitPrice = this.currentVariant.price;
    const compareAtPrice = this.currentVariant.compare_at_price;
    const totalPrice = unitPrice * quantity;
    
    // Format the sale price
    const formattedSalePrice = this.formatPrice(totalPrice);
    
    // Check if this is a discounted product
    const isOnSale = compareAtPrice && compareAtPrice > unitPrice;
    
    if (isOnSale) {
      // For discounted products, update both original and sale prices
      const totalCompareAtPrice = compareAtPrice * quantity;
      const formattedCompareAtPrice = this.formatPrice(totalCompareAtPrice);
      
      // Update the crossed-out original price (in price__sale section)
      const compareAtPriceElement = priceElement.querySelector('.price__sale s.price-item--regular');
      if (compareAtPriceElement) {
        compareAtPriceElement.textContent = formattedCompareAtPrice;
      }
      
      // Update the sale price
      const salePriceElement = priceElement.querySelector('.price-item--sale.price-item--last');
      if (salePriceElement) {
        salePriceElement.textContent = formattedSalePrice;
      }
    } else {
      // For regular products, update the regular price
      const regularPriceElement = priceElement.querySelector('.price__regular .price-item--regular');
      if (regularPriceElement) {
        regularPriceElement.textContent = formattedSalePrice;
      }
      
      // Also update sale price element if it exists (fallback)
      const salePriceElement = priceElement.querySelector('.price-item--sale.price-item--last');
      if (salePriceElement) {
        salePriceElement.textContent = formattedSalePrice;
      }
    }
  }

  formatPrice(price) {
    // Use Shopify's money formatting if available, otherwise fallback to basic formatting
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(price);
    }
    
    // Basic fallback formatting (assumes euros based on the HTML example)
    return (price / 100).toFixed(2).replace('.', ',') + ' €';
  }

  setupQuantityListener() {
    const setupListener = () => {
      const quantityInput = document.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.addEventListener('change', () => {
          if (this.currentVariant) {
            this.updateQuantityBasedPrice();
            this.updateBuyBarButtonPrice();
          }
        });
        
        // Also listen for input events (when user types)
        quantityInput.addEventListener('input', () => {
          if (this.currentVariant) {
            this.updateQuantityBasedPrice();
            this.updateBuyBarButtonPrice();
          }
        });
        
        // Run initial calculation on page load if we have a current variant
        if (this.currentVariant) {
          this.updateQuantityBasedPrice();
          this.updateBuyBarButtonPrice();
        }
      }
    };

    // Try to set up immediately if DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupListener);
    } else {
      setupListener();
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend [data-variant-legend]');
      const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      legend.textContent = selectedOption.getAttribute('value');
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    this.dismissed = false;
    this._classes = { show: "show" };

    this._setupCloseButton();
    this._setupVisibilityObserver();
  }

  _findMainAddButton() {
    // Pick the main PDP add-to-cart button (not the one inside this sticky bar).
    const candidates = document.querySelectorAll('[name="add"]');
    for (const btn of candidates) {
      if (!btn.closest('product-buy-bar')) return btn;
    }
    return null;
  }

  _setupVisibilityObserver() {
    const target =
      this._findMainAddButton() ||
      document.querySelector('.product-form:not(product-buy-bar .product-form)') ||
      document.querySelector('.product-form');
    if (!target) return;

    const self = this;
    // Show the sticky bar only when the main add-to-cart button has scrolled
    // ABOVE the viewport (user scrolled past it). Hide it in every other case:
    // button visible, button below the fold on load, or user scrolled back up.
    self._mainButtonScrolledPast = false;

    this._observer = new IntersectionObserver(
      (entries) => {
        if (self.dismissed) return;
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Button is in view — hide the bar.
            self._mainButtonScrolledPast = false;
            self.classList.remove(self._classes.show);
          } else {
            // Button left the viewport. Check direction:
            // bottom < 0 → button is above the viewport (user scrolled past).
            // bottom >= 0 → button is below the viewport (page load or top).
            const scrolledPast = entry.boundingClientRect.bottom < 0;
            self._mainButtonScrolledPast = scrolledPast;
            if (scrolledPast) {
              self.classList.add(self._classes.show);
            } else {
              self.classList.remove(self._classes.show);
            }
          }
        });
      },
      { threshold: 0, rootMargin: "0px 0px -16px 0px" }
    );

    this._observer.observe(target);

    // Separate observer for the footer: hides the bar when the footer enters
    // the viewport, re-shows when it leaves if the user is still past the
    // main button.
    const observeFooter = () => {
      const siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      self._footerObserver = new IntersectionObserver(
        (entries) => {
          if (self.dismissed) return;
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              self.classList.remove(self._classes.show);
            } else if (self._mainButtonScrolledPast) {
              self.classList.add(self._classes.show);
            }
          });
        },
        { threshold: 0 }
      );
      self._footerObserver.observe(siteFooter);
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", observeFooter);
    } else {
      observeFooter();
    }
  }

  _setupCloseButton() {
    const closeBtn = this.querySelector('[data-buy-bar-close]');
    if (!closeBtn) return;
    closeBtn.addEventListener('click', () => {
      this.dismissed = true;
      this.classList.remove(this._classes.show);
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      if (this._footerObserver) {
        this._footerObserver.disconnect();
        this._footerObserver = null;
      }
      // No persistence: refreshing or navigating naturally restores the bar.
    });
  }

}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);

// Simple Product Quantity Handler for products without variants
class SimpleProductQuantityHandler {
  constructor() {
    // Only initialize if this is a simple product (no variant selectors)
    const hasVariantSelector = document.querySelector('variant-selects, variant-radios');
    if (hasVariantSelector) return;
    
    this.init();
  }
  
  init() {
    this.setupQuantityListener();
    this.getProductData();
    
    // Run initial calculation
    if (this.productData) {
      this.updateQuantityBasedPrice();
      this.updateBuyBarButtonPrice();
    }
  }

  updateBuyBarButtonPrice() {
    const priceNode = document.querySelector('product-buy-bar [data-buy-bar-price]');
    if (!priceNode || !this.productData) return;
    const quantityInput = document.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? (parseInt(quantityInput.value) || 1) : 1;
    const variant = this.productData.selected_or_first_available_variant || this.productData;
    const unitPrice = variant.price || this.productData.price;
    if (unitPrice == null) return;
    priceNode.textContent = this.formatPrice(unitPrice * quantity);
  }
  
  getProductData() {
    // Try to get product data from existing script tags or data attributes
    const productDataScript = document.querySelector('script[type="application/json"][data-product-json]');
    if (productDataScript) {
      try {
        this.productData = JSON.parse(productDataScript.textContent);
      } catch (e) {
        console.warn('Could not parse product JSON data');
      }
    }
    
    // Fallback: try to extract price from the current price display
    if (!this.productData) {
      const priceElement = document.querySelector('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale.price-item--last');
      if (priceElement) {
        // Extract price from text (remove currency symbols and convert to cents)
        const priceText = priceElement.textContent.trim();
        const priceMatch = priceText.match(/[\d,]+[.,]\d{2}/);
        if (priceMatch) {
          const cleanPrice = priceMatch[0].replace(',', '.');
          const priceInCents = Math.round(parseFloat(cleanPrice) * 100);
          this.productData = {
            price: priceInCents,
            selected_or_first_available_variant: {
              price: priceInCents
            }
          };
        }
      }
    }
  }
  
  setupQuantityListener() {
    const quantityInput = document.querySelector('input[name="quantity"]');
    if (quantityInput) {
      quantityInput.addEventListener('change', () => {
        this.updateQuantityBasedPrice();
        this.updateBuyBarButtonPrice();
      });
      
      quantityInput.addEventListener('input', () => {
        this.updateQuantityBasedPrice();
        this.updateBuyBarButtonPrice();
      });
    }
  }
  
  updateQuantityBasedPrice() {
    const quantityInput = document.querySelector('input[name="quantity"]');
    const priceElement = document.querySelector('[id^="price-"]');
    
    if (!quantityInput || !priceElement || !this.productData) return;
    
    const quantity = parseInt(quantityInput.value) || 1;
    const variant = this.productData.selected_or_first_available_variant || this.productData;
    const unitPrice = variant.price || this.productData.price;
    const compareAtPrice = variant.compare_at_price;
    const totalPrice = unitPrice * quantity;
    
    // Format the sale price
    const formattedSalePrice = this.formatPrice(totalPrice);
    
    // Check if this is a discounted product
    const isOnSale = compareAtPrice && compareAtPrice > unitPrice;
    
    if (isOnSale) {
      // For discounted products, update both original and sale prices
      const totalCompareAtPrice = compareAtPrice * quantity;
      const formattedCompareAtPrice = this.formatPrice(totalCompareAtPrice);
      
      // Update the crossed-out original price (in price__sale section)
      const compareAtPriceElement = priceElement.querySelector('.price__sale s.price-item--regular');
      if (compareAtPriceElement) {
        compareAtPriceElement.textContent = formattedCompareAtPrice;
      }
      
      // Update the sale price
      const salePriceElement = priceElement.querySelector('.price-item--sale.price-item--last');
      if (salePriceElement) {
        salePriceElement.textContent = formattedSalePrice;
      }
    } else {
      // For regular products, update the regular price
      const regularPriceElement = priceElement.querySelector('.price__regular .price-item--regular');
      if (regularPriceElement) {
        regularPriceElement.textContent = formattedSalePrice;
      }
      
      // Also update sale price element if it exists (fallback)
      const salePriceElement = priceElement.querySelector('.price-item--sale.price-item--last');
      if (salePriceElement) {
        salePriceElement.textContent = formattedSalePrice;
      }
    }
  }
  
  formatPrice(price) {
    // Use Shopify's money formatting if available
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(price);
    }
    
    // Basic fallback formatting (assumes euros based on the example)
    return (price / 100).toFixed(2).replace('.', ',') + ' €';
  }
}

// Initialize simple product handler when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new SimpleProductQuantityHandler();
});